<template>
    <div :style="{ 'background-image': `url(${background})`}" class="mantel">
        <h1 class="mantel__title" v-html="title"></h1>
        <p class="mantel__paragraph" v-html="paragraph"></p>
    </div>
</template>

<script>
    export default {
        name: 'Mantel',

        components: {},

        props: {
            background: { type: String, required: true },
            title:      { type: String, required: true },
            paragraph:  { type: String, required: true },
        },
    };
</script>

<style lang="scss">
    @import '~@/assets/styles/abstracts/_variables';
    @import '~@/assets/styles/abstracts/_placeholders';
    @import '~@/assets/styles/abstracts/_mixins';

    .mantel {
        display:         flex;
        flex-direction:  column;
        justify-content: center;
        align-items:     center;

        height:          35rem;
        background:      no-repeat top center;
        background-size: cover;

        color:           white;

        background-color: $gray-300;

        &__title {
            @extend %font-OpenSans-light;
            font-size: 5rem;
        }

        &__paragraph {
            max-width:  70rem;
            text-align: center;
        }
    }
</style>
